import styled from 'styled-components';
import { astriskStyle } from 'src/styles/CommonStyles.styled';

export const PhysicianFinderContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
`;

export const CheckRowDiv = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: ${({ width }) => (width ? width : '100%')};
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

export const Title = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;

    ${astriskStyle};
`;

export const SubTitle = styled.div`
    font-family: AvenirNextWorld Italic;
    color: #140f4b;
    font-size: 12px;
    margin-bottom: 8px;
    padding: ${({ padding }) => (padding ? padding : '')};
`;
